import React from "react";
import { Outlet } from "react-router";

import { Topbar } from "./titlebar";

export function TopbarLayout({ children }: React.PropsWithChildren) {
  return (
    <div className="grid h-dvh grid-rows-[auto_1fr]">
      <Topbar />
      <main className="overflow-y-auto h-full">{children ?? <Outlet />}</main>
    </div>
  );
}
